// frontend/src/components/ReviewPage/useFilterApplicability.ts
//
// Row 23: page-state → applicability. Shares the get_controls query (5-min staleTime,
// react-query dedupe) with the cascade/dim consumers; the scan is memoized per state change.
import { useMemo } from 'react'
import { usePageControls } from '~/api/hooks/useCharts'
import { computeFilterApplicability, type FilterApplicability } from './filterApplicability'

export interface UseFilterApplicabilityArgs {
  factTable: string
  kpi: string
  groupBy: string[]
  filters: Record<string, string[]>
}

export function useFilterApplicability(args: UseFilterApplicabilityArgs): FilterApplicability {
  const controls = usePageControls(args.factTable)
  return useMemo(
    () =>
      computeFilterApplicability({
        dimsView: controls.data?.dims_view ?? [],
        kpi: args.kpi,
        groupBy: args.groupBy,
        filters: args.filters,
      }),
    [controls.data, args.kpi, args.groupBy, args.filters],
  )
}
